ObjectUtils.define('UICaptchaController', UIController, {

  enableDebug: 0,
  _isScriptLoaded: false,
  _isScriptInjected: false,
  _queue: [],

  didLoad: function didLoad(container, data) {
    this._initScript(data);
    this._renderCaptcha(container, data);
  },

  _initScript: function _initScript(data) {
    if (this._isScriptInjected) {
      return;
    }

    // Load this script async to avoid SEO penalties
    ObjectUtils.define('onCaptchaScriptLoad', FunctionUtils.bind(this, this._onScriptLoad));

    var url = 'https://www.google.com/recaptcha/api.js?onload=onCaptchaScriptLoad&render=explicit';
    this.enableDebug && Logger.log(this, 'Injecting captcha script', url);
    DOM.injectScript(url);

    this._isScriptInjected = true;
  },

  _onScriptLoad: function _onScriptLoad() {
    this._isScriptLoaded = true;

    ArrayUtils.each(this._queue, FunctionUtils.bind(this, function(index, data) {
      var container = data.container;
      delete data.container;

      this._renderCaptcha(container, data);
    }));
    this._queue = [];
  },

  _renderCaptcha: function _renderCaptcha(container, data) {
    data = data || {};

    // This can be triggered multiple times. Once on page load, once when overlay is presented.
    if (DOM.getAttribute(container, 'isCaptchaSetup')) {
      return;
    }

    if (!DOM.isVisible(container)) {
      return false;
    }

    if (!this._isScriptLoaded) {
      data.container = container;
      this._queue.push(data);
      return;
    }

    DOM.setAttribute(container, 'isCaptchaSetup', 1);

    var captchaType = data.size;
    if (data.isApp) {
      data.callback = function captchaDidComplete(token) {
        var url = Url.parse(data.returnUrl)
        url.addQueryParams({
          captchaToken: token,
          captchaType: captchaType,
        });
        window.location.href = url.toString();
      };
    } else if (captchaType === CaptchaType.INVISIBLE) {
      data.callback = function captchaDidComplete(token) {
        var form = DOM.findParentByTag(container, 'form');
        UIFormController.submit(form, null, {
          force: true,
        });
      };
    }

    var captchaContainer = DOM.findByClass(container, 'captchaContainer');
    grecaptcha.render(captchaContainer[0], data);

    if (data.isApp) {
      grecaptcha.execute();
    }
  },

  maybeHandleFormSubmit: function maybeHandleFormSubmit(form, params) {
    var bypass = parseInt(params.bypass);
    if (
      bypass
      || params.captchaType !== CaptchaType.INVISIBLE
      || params['g-recaptcha-response']
    ) {
      return false;
    }

    grecaptcha.execute();

    return true;
  },

});
